var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:[{'heading-icon':true},_vm.classes],on:{"click":_vm.clicked}},[_c('Icon',{staticClass:"icon",attrs:{"type":_vm.settings.icon}}),_c('span',{staticClass:"heading",domProps:{"innerHTML":_vm._s(_vm.settings.label)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }